import { useEffect, useState } from 'react';

/**
 * Punto de quiebre único para las vistas que se comportan distinto en
 * escritorio vs. celular (p. ej. el calendario de OT: mes vs. semana). Un solo
 * componente con dos ramas de render, no archivos duplicados por plataforma.
 */
// Mismo corte que usa el resto de la app para "móvil" (ver app.css), para que
// una ventana de escritorio angosta no dispare por error una vista pensada
// para celular.
export const PUNTO_QUIEBRE_MOVIL = 640;

export function useEsMovil(anchoMaximo: number = PUNTO_QUIEBRE_MOVIL): boolean {
  const [esMovil, setEsMovil] = useState(() =>
    typeof window === 'undefined' ? false : window.innerWidth <= anchoMaximo,
  );

  useEffect(() => {
    const consulta = window.matchMedia(`(max-width: ${anchoMaximo}px)`);
    const actualizar = (): void => setEsMovil(consulta.matches);
    actualizar();
    consulta.addEventListener('change', actualizar);
    return () => consulta.removeEventListener('change', actualizar);
  }, [anchoMaximo]);

  return esMovil;
}
